module.exports = __webpack_public_path__ + "static/media/ajax-Loader.eb619bb7.gif";